module.exports = new __parcel__URL__("Warlock_50.a638d31b.png").toString();